import { render, staticRenderFns } from "./AddRepToPropertyRequest.vue?vue&type=template&id=820bffa0&"
import script from "./AddRepToPropertyRequest.vue?vue&type=script&lang=js&"
export * from "./AddRepToPropertyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports